import { ActionChip, useOverlay } from '@fs/zion-ui'

import React from 'react'
import { useTranslation } from 'react-i18next'
import MakeLivingPersonDialogOverlay from './MakeLivingPersonDialogOverlay'

export default function MakeLivingActionChip() {
  const { t } = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <span style={{ display: 'inline-block' }}>
        <ActionChip label={t('person.status.makeLiving', 'Make Living')} onClick={overlay.handleClick} selected />
      </span>
      <MakeLivingPersonDialogOverlay {...overlay} />
    </>
  )
}
